import { Checkbox } from "@jti/core-components/components/Checkbox";
import type { OrderAttribute } from "@jti/magento";
import { Controller, useFormContext, useTranslations } from "@jti/ui";

import { ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER } from "@checkout-v2/features/OrderAttributes/const";
import { checkboxFormValueAdapter } from "@checkout-v2/features/OrderAttributes/utils/checkboxFormValueAdapter";
import { coerceAttributeBoolean } from "@checkout-v2/features/OrderAttributes/utils/coerceAttributeBoolean/coerceAttributeBoolean";
import { checkboxInputOrderAttributesValidationRulesFactory } from "@checkout-v2/features/OrderAttributes/utils/orderAttributesValidationRulesFactory";

export type CheckboxAttributeInputProps = { attribute: OrderAttribute };

export const CheckboxAttributeInput = ({ attribute }: CheckboxAttributeInputProps) => {
  const { control } = useFormContext();
  const { __ } = useTranslations();

  const id = `${ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER}-${attribute.code}`;
  const name = `${ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER}.${attribute.code}`;
  const initialBoolean = coerceAttributeBoolean(attribute.value);
  const validation = checkboxInputOrderAttributesValidationRulesFactory(attribute, __);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={checkboxFormValueAdapter(initialBoolean, attribute.data_type)}
      rules={validation}
      render={({ field: { onChange, value, ...fieldProps }, fieldState }) => (
        <Checkbox
          id={id}
          checked={coerceAttributeBoolean(value)}
          onCheckedChange={(checked) => onChange(checkboxFormValueAdapter(checked, attribute.data_type))}
          data-testid={id}
          label={attribute.label}
          required={attribute.is_required}
          status={fieldState.error ? "error" : "default"}
          errorMessage={fieldState.error?.message}
          {...fieldProps}
        />
      )}
    />
  );
};
